interface JsonLDProps {
  data: Record<string, unknown>;
}

export default function JsonLD({ data }: JsonLDProps) {
  return null;
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫之家',
    url: 'https://www.hanmanzhijia.com',
    description: '韩漫之家作为专业在线阅读平台，提供高清下拉式韩漫全集，真正实现韩国漫画免费读。',
    sameAs: [
      'https://weibo.com/hanmanzhijia',
      'https://www.hanmanzhijia.com',
    ],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫之家',
    url: 'https://www.hanmanzhijia.com',
    description: '免费韩漫在线阅读平台，提供高清下拉式韩漫全集，韩国漫画免费读。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.hanmanzhijia.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url?: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url || undefined,
    })),
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: url,
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫之家',
      url: 'https://www.hanmanzhijia.com',
    },
  };
}

export function getArticleSchema(comic: {
  title: string;
  author: string;
  description: string;
  cover: string;
  updateDate: string;
  category: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: comic.title,
    author: {
      '@type': 'Person',
      name: comic.author,
    },
    description: comic.description,
    image: comic.cover,
    datePublished: comic.updateDate,
    dateModified: comic.updateDate,
    articleSection: comic.category,
    publisher: {
      '@type': 'Organization',
      name: '韩漫之家',
    },
  };
}

export function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}